import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomBreakPointsProviders } from './breakpoints';
import { FlexAlignDirective } from './flex-align.directive';
import { FlexOffsetDirective } from './flex-offset.directive';
import { FlexOrderDirective } from './flex-order.directive';
import { FlexDirective } from './flex.directive';
import { LayoutAlignDirective } from './layout-align.directive';
import { LayoutGapDirective } from './layout-gap.directive';
import { LayoutHideDirective } from './layout-hide.directive';
import { LayoutShowDirective } from './layout-show.directive';
import { LayoutWrapDirective } from './layout-wrap.directive';
import { LayoutDirective } from './layout.directive';

@NgModule({
  imports: [CommonModule, FlexLayoutModule],
  declarations: [
    FlexAlignDirective,
    FlexOffsetDirective,
    FlexOrderDirective,
    FlexDirective,
    LayoutAlignDirective,
    LayoutGapDirective,
    LayoutWrapDirective,
    LayoutDirective,
    LayoutHideDirective,
    LayoutShowDirective,
  ],
  exports: [
    FlexAlignDirective,
    FlexOffsetDirective,
    FlexOrderDirective,
    FlexDirective,
    LayoutAlignDirective,
    LayoutGapDirective,
    LayoutWrapDirective,
    LayoutDirective,
    LayoutHideDirective,
    LayoutShowDirective,
  ],
  providers: [CustomBreakPointsProviders],
})
export class LayoutModule {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/ui/layout/layout.module.ts